import React from "react";
import { Modal } from "@/components/ui/kit";
import { formatGs, formatDate, LOCATION_NAMES } from "@/lib/format";

export const PurchaseDetailModal = ({ purchase, onClose }) => {
  if (!purchase) return null;
  const p = purchase;
  return (
    <Modal open={!!p} onClose={onClose} title={`Factura ${p.invoice_number || "s/n"}`} wide top>
      <div className="space-y-4" data-testid="purchase-detail">
        <div className="grid grid-cols-2 gap-3 text-sm p-4 rounded-xl bg-secondary/40 border border-border">
          <div><div className="text-xs uppercase text-muted-foreground">Proveedor</div><div className="font-medium">{p.supplier || "—"}</div></div>
          <div><div className="text-xs uppercase text-muted-foreground">Comprobante</div><div>{p.invoice_type === "con_factura" ? "Con Factura" : "Sin Factura"}</div></div>
          <div><div className="text-xs uppercase text-muted-foreground">Fecha factura</div><div className="font-data">{p.invoice_date ? p.invoice_date.split("-").reverse().join("/") : "—"}</div></div>
          <div><div className="text-xs uppercase text-muted-foreground">Registrada</div><div className="font-data text-xs">{formatDate(p.timestamp)} · {p.user_name} · {LOCATION_NAMES[p.location]}</div></div>
        </div>
        <table className="w-full text-sm">
          <thead className="text-xs uppercase text-muted-foreground"><tr><th className="text-left p-2">Producto</th><th className="text-right p-2">Cant.</th><th className="text-right p-2">Costo u.</th><th className="text-right p-2">Subtotal</th></tr></thead>
          <tbody>
            {p.items.map((i, idx) => (
              <tr key={idx} className="border-t border-border">
                <td className="p-2">{i.name}{i.barcode && <span className="block text-xs text-muted-foreground font-data">{i.barcode}</span>}</td>
                <td className="p-2 text-right font-data">{i.quantity}</td>
                <td className="p-2 text-right font-data">{formatGs(i.cost)}</td>
                <td className="p-2 text-right font-data font-semibold">{formatGs(i.cost * i.quantity)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="flex justify-end pt-3 border-t border-border"><span className="font-head font-bold text-lg">Total <span className="font-data text-primary" data-testid="purchase-detail-total">{formatGs(p.total)}</span></span></div>
      </div>
    </Modal>
  );
};
